/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReplacer } from '../../factoriesAny.js';
export var replacerDependencies = {
  createReplacer: createReplacer
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesReplacer.generated.js
// module id = 1494
// module chunks = 0